import { ReactNode } from "react";
import { ArrowLeft } from "lucide-react";
import MyBackButton from "../components/MyBackButton";

export interface LayoutAction {
  id: string;
  icon: ReactNode;
  label?: string;
  onClick?: () => void;
}

interface MyLayoutProps {
  title?: string;

  actions?: LayoutAction[];

  top?: ReactNode;
  topCarousel?: ReactNode;
  topScroller?: ReactNode;

  main?: ReactNode;
  sidebar?: ReactNode;

  footer?: ReactNode;
  footer2?: ReactNode;

  onBack?: () => void;
}

export default function MyLayout({
  title,
  actions = [],

  top,
  topCarousel,
  topScroller,

  main,
  sidebar,

  footer,
  footer2,

  onBack,
}: MyLayoutProps) {
  return (
    <section className="min-h-screen bg-slate-50">

      {/* HEADER */}

      <div className="sticky top-0 z-40 backdrop-blur-xl bg-white/80 border-b">

        <div className="max-w-7xl mx-auto px-4 py-3">

          <div className="flex items-center justify-between">

            <div className="flex items-center gap-3">

              {onBack && (
                <button
                  onClick={onBack}
                  className="
                    h-10 w-10
                    rounded-xl
                    border
                    bg-white
                    flex items-center justify-center
                    hover:bg-slate-100
                    transition
                  "
                >
                  <ArrowLeft size={18} />
                </button>
              )}

              <div>
                <h1 className="text-xl font-bold text-slate-900">
                  {title}
                </h1>
              </div>
            </div>

            {/* ACTIONS */}

            <div className="flex items-center gap-2">

              {actions.map((action) => (
                <button
                  key={action.id}
                  title={action.label}
                  onClick={action.onClick}
                  className="
                    h-10
                    w-10
                    rounded-xl
                    border
                    bg-white
                    flex
                    items-center
                    justify-center
                    hover:bg-slate-100
                    transition
                  "
                >
                  {action.icon}
                </button>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* CONTENT */}

      <div className="max-w-7xl mx-auto px-4 md:px-6 py-5">

        {top}

        {topCarousel && (
          <div className="mb-5">
            {topCarousel}
          </div>
        )}

        {topScroller && (
          <div className="mb-5">
            {topScroller}
          </div>
        )}

        <div className="flex gap-6">

          <main className="flex-1 min-w-0">
            {main}
          </main>

          {sidebar && (
            <aside className="hidden xl:block w-[320px]">
              <div className="sticky top-24">
                {sidebar}
              </div>
            </aside>
          )}
        </div>

        {footer && (
          <div className="mt-10">
            {footer}
          </div>
        )}

        {footer2 && (
          <div className="mt-5">
            {footer2}
          </div>
        )}
      </div>
    </section>
  );
}